<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'logisticsLOReportEdit',
    components: {
      baseEdit,
    },
  };
</script>
